<template>
  <div class="main-layout yx-student-predicted-page">
    <el-card class="box-inner">
      <c-title slot="header" title="入学测试" :back="false"></c-title>
      <div class="div-scroll">
        <div class="tips-container">
          <div class="tips">
            <div class="title">
              <i class="el-icon-info"></i><span>温馨提示</span>
            </div>
            <p>1、请认真学习入学资料并完成学习测试；</p>
            <p>2、测试分数≥90分即通过；通过后才可进行线上预报到工作。</p>
          </div>
        </div>
        <div class="predicted-list">
          <div
            class="pre-item"
            v-for="(item, index) in predictedList"
            :key="item.id"
            @click="goto(item)"
          >
            <img
              v-if="item.id == 2"
              :src="
                require('../../../../../assets/images/prediect/test_status_' +
                  item.status +
                  '.png')
              "
              class="status-img"
            />
            <div class="item-index">
              <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    (index + 1) +
                    '.png')
                "
                alt=""
                class="index-img"
                :class="{ first: index == 0 }"
              />
              <!-- <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    item.icon +
                    '.png')
                "
                alt=""
                class="icon"
              /> -->
            </div>
            <div class="item-left">
              <p class="title ellipsis">{{ item.name }}</p>
              <p class="ellipsis">{{ item.brief }}</p>
              <p class="ellipsis">
                <!-- <span
                  >状态：<span
                    :class="{
                      grey: item.status == 0,
                      green: item.status == 1,
                      red: item.status == 2,
                    }"
                    >{{
                      item.status == 0
                        ? "未开始"
                        : item.status == 1
                        ? "进行中"
                        : "已结束"
                    }}</span
                  ></span
                > -->
              </p>
              <p class="ellipsis">
                <!-- 距离结束时间：<span class="red">{{
                  item.lastTime || "--"
                }}</span> -->
              </p>
            </div>
            <div class="item-right">
              <!-- 0未完成 1已完成 2驳回 3审核通过 4审核中 -->
              <el-button type="primary" v-if="item.id == 1" size="small"
                >去学习</el-button
              >
              <el-button
                type="primary"
                v-if="item.id == 2"
                size="small"
                :disabled="item.status == 1"
                >去测试</el-button
              >
              <el-button
                type="primary"
                v-else-if="item.id == 3"
                size="small"
                :disabled="item.status == -1"
                >查看</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
      predictedList: [],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.checkTestIsComplete();
  },
  mounted() {},
  methods: {
    goto(data) {
      // 0未完成 1已完成 2驳回 3审核中 4审核通过  5已拒绝
      // 0,1,2可跳转编辑
      this.pushRoute(data);
    },

    // 跳转路由
    pushRoute(data) {
      // console.log(data);
      if (data.id == 1) {
        if (data.url) {
          this.$router.push(data.url);
        }
      } else if (data.id == 2) {
        this.checkInfoIsComplete(data);
        // this.$router.push(data.url);
      } else {
        if (data.url && data.status != -1) {
          this.$router.push(data.url);
        } else {
          return this.$message.warning("请先进行入学测试！");
        }
      }
    },
    getTestList(status) {
      this.predictedList = [
        {
          brief: "请认真学习入学资料",
          description: null,
          icon: "zhengbingbaomin",
          id: "1",
          name: "入学资料",
          type: "data",
          url: "/welcome/student/entryTest/study",
        },
        {
          brief: "请按要求完成新生入学测试",
          description: null,
          icon: "zhuanyetiaozhen",
          id: "2",
          name: "学习测试",
          type: "data",
          status,
          url: "/welcome/student/entryTest/test",
        },
        {
          brief: "查看测试结果",
          description: null,
          icon: "lvsetongdao",
          id: "3",
          name: "测试结果",
          type: "data",
          status,
          url: "/welcome/student/entryTest/result",
        },
      ];
    },
    // 校验是否完成了入学测试
    checkTestIsComplete() {
      this.isLoading = true;
      this.$http
        .get("/welcome-forecast/test/isComplete")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.getTestList(res.data);
          } else {
            this.getTestList(0);
          }
        })
        .catch((err) => {});
    },
    // 校验是否完成了信息登记
    checkInfoIsComplete(data) {
      if(data.status == 1) return this.$message.warning('您已完成测试，无需再次测试！')
      this.$http.get("/account/base/student/config/isComplete").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.$router.push(data.url);
        } else {
          this.$message.warning("请先完成个人信息填写!");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tips-container {
  padding-top: 20px;
  padding-left: 30px;
  .tips {
    margin-bottom: 15px;
    color: #787878;

    i.el-icon-info {
      vertical-align: middle;
      font-size: 18px;
      margin-right: 5px;
      color: #409eff;
    }

    .title {
      font-size: 16px;
      line-height: 30px;
      // padding-left: 25px;
      color: #5a5a5a;
    }

    p {
      text-indent: 2em;
      line-height: 26px;
    }
  }
}
</style>
